<template>
    <b-row>
        <b-col md="12">
            <b-card title="Статистика" class="card-custom gutter-b">
                <b-row>
                    <b-col md="4">
                        <widget-chart2/>
                    </b-col>
                    <b-col md="4">
                        <widget-chart1/>
                    </b-col>
                    <b-col md="4">
                        <widget-chart3/>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
        <b-col md="12">
            <b-card title="Новости и объявления" class="card-custom gutter-b">
                <b-card class="ad-item">
                    <div class="text-muted">02.04.2022</div>
                    <div>
                        Бүгүн «Ошэлектр» ААКтын жамааты ишембиликке чыгышты. Ишембиликте Ошэлектр ишканасынын айланасы
                        жана арыктары тазаланып, бак дарактар акталды.
                    </div>
                </b-card>
                <b-card class="ad-item">
                    <div class="text-muted">01.04.2022</div>
                    <div>
                        3-4-апрель күндөрү 35/10-6кВ электр тармактардагы капиталдык жана учурдагы ремонт иштерине
                        байланыштуу саат 08:00дөн 17:00 гө чейин төмөнкү даректерде электр энергия убактылуу үзгүлтүккө
                        учурайт:<br/>
                        3-апрель:<br/>
                        - Баткен районунун Кара-Бак, Суу-Башы, Ак-Турпак, Төрт-Гүл айыл өкмөттөрү.<br/>
                        4-апрель:<br/>
                        - Кадамжай районунун Бирлик айыл өкмөтү.<br/>
                        - Баткен районунун Суу-Башы, Ак-Турпак, Төрт-Гүл айыл өкмөттөрү.<br/>
                        - Ноокат районунун Беш-Тал, Борко, Калинин, Чечме-Сай, Темир-Корук, Нойгут, Үч-Кемпир, Киров
                        айылдары, Ноокат шаары.<br/>
                        - Кара-Суу районунун Кашкар-Кыштак, Кенжекул, Кашкар, Мөнөк, Маданият, Мачак, Кайрат
                        айылдары<br/>
                        - Ош шаарынын Жапалак айылы, Төлөнбаев, Аттокуров, Тоголок Молдо, Бердибаев, Сасыкбаев,
                        Бөкөнбаев, Салиева, Раззаков, Касымбеков көчөлөрү, Касымбеков №15,13,13а,3,4,5,6, Салиева
                        №14а,16,18,20,20в,19а,33,41,39,43,45, Раззаков №20а,22,24 көп кабаттуу үйлөр.<br/>
                    </div>
                </b-card>
                <b-card class="ad-item">
                    <div class="text-muted">31.03.2022</div>
                    <div>
                        Өзгөчө кырдаалга даярдык<br/>
                        Ош, Баткен райондук электр тармактары жарандык коргонуунун, энергия менен жабдуу жана жарыкты
                        чүмбөттөө кызматынын абалын, комплекстик текшерүүдөн өткөрүү иш чарасы болуп өттү. Комплекстик
                        текшерүүдө Кыргыз Республикасынын Өзгөчө кырдаалдар министрлигинен келген адистер электр
                        тармактардын шаймандарын, унаа техникаларын жана өзгөчө кырдаал жаралган жерде кызмат көрсөтүүгө
                        даярдыгын текшеришти.
                    </div>
                </b-card>
            </b-card>
        </b-col>

    </b-row>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import WidgetChart1 from "../widgets/WidgetChart1";
    import WidgetChart2 from "../widgets/WidgetChart2";
    import WidgetChart3 from "../widgets/WidgetChart3";

    export default {
        name: "dashboard",
        components: {WidgetChart1, WidgetChart2, WidgetChart3},
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [{title: "Главная"}]);
        },
        methods: {}
    };
</script>
